import { colors } from '../styles';

/**
 * Returns a contrasting text color (black or white) based on background color brightness
 * @param hexColor - Hex color code (with or without #)
 * @returns White (#fff) for dark backgrounds, black (#000) for light backgrounds
 */
export const getContrastColor = (hexColor: string): string => {
    // Default to black if no color provided
    if (!hexColor) return colors.textColor1;

    // Remove hash if present
    const hex = hexColor.replace('#', '');

    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calculate brightness (YIQ formula)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Return white for dark backgrounds, black for light backgrounds
    // Using more precise threshold to catch darker green backgrounds
    return brightness < 140 ? '#fff' : '#000';
};

export default getContrastColor;